export const PRIMARY_COLOR = '#015f80';

export const SECONDARY_COLOR = '#838383';
